/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useState } from 'react'

interface ImportFromExcelContextProps {
  activeTab: number
  setActiveTab: (activeTab: number) => void
  previewSpreadsheet: any[]
  setPreviewSpreadsheet: (previewSpreadsheet: any[]) => void
  translationMapping: any // Seu tipo de dados para translationMapping
  setTranslationMapping: (translationMapping: any) => void
  updateInOmie: boolean
  setUpdateInOmie: (updateInOmie: boolean) => void
  calculateWeight: boolean
  setCalculateWeight: (calculateWeight: boolean) => void
  calculateLength: boolean
  setCalculateLength: (calculateLength: boolean) => void
  defaultMapping: boolean
  setDefaultMapping: (defaultMapping: boolean) => void
  review: Review
  setReview: (review: Review) => void
  loadingPercentage: any
  setLoadingPercentage: (LoadingPercentage: any) => void
}

interface Review {
  missingColumns: []
  wrongColumns: []
}

const ImportFromExcelContext = createContext<ImportFromExcelContextProps>({
  activeTab: 0,
  setActiveTab: () => {},
  previewSpreadsheet: [],
  setPreviewSpreadsheet: () => {},
  translationMapping: {}, // Valor inicial para translationMapping
  setTranslationMapping: () => {},
  updateInOmie: false,
  setUpdateInOmie: () => {},
  calculateWeight: false,
  setCalculateWeight: () => {},
  calculateLength: false,
  setCalculateLength: () => {},
  defaultMapping: true,
  setDefaultMapping: () => {},
  review: { missingColumns: [], wrongColumns: [] },
  setReview: () => {},
  loadingPercentage: 0,
  setLoadingPercentage: () => {},
})

export default ImportFromExcelContext

export const ImportFromExcelProvider: React.FC<any> = ({ children }) => {
  const [activeTab, setActiveTab] = useState<number>(0)
  const [loadingPercentage, setLoadingPercentage] = useState<any>(0)
  const [previewSpreadsheet, setPreviewSpreadsheet] = useState<any[]>([]) // Novo estado para o array
  const [translationMapping, setTranslationMapping] = useState<any>({}) // Estado para translationMapping
  const [updateInOmie, setUpdateInOmie] = useState<boolean>(false)
  const [calculateLength, setCalculateLength] = useState<boolean>(false)
  const [calculateWeight, setCalculateWeight] = useState<boolean>(false)
  const [defaultMapping, setDefaultMapping] = useState<boolean>(true)
  const [review, setReview] = useState<Review>({
    missingColumns: [],
    wrongColumns: [],
  })

  return (
    <ImportFromExcelContext.Provider
      value={{
        activeTab,
        setActiveTab,
        previewSpreadsheet,
        setPreviewSpreadsheet,
        translationMapping,
        setTranslationMapping,
        updateInOmie,
        setUpdateInOmie,
        calculateLength,
        setCalculateLength,
        calculateWeight,
        setCalculateWeight,
        defaultMapping,
        setDefaultMapping,
        review,
        setReview,
        loadingPercentage,
        setLoadingPercentage,
      }}
    >
      {children}
    </ImportFromExcelContext.Provider>
  )
}
